import { render } from "./NewVisitModal.vue?vue&type=template&id=7a2a37c8&scoped=true"
import script from "./NewVisitModal.vue?vue&type=script&lang=js"
export * from "./NewVisitModal.vue?vue&type=script&lang=js"

import "./NewVisitModal.vue?vue&type=style&index=0&id=7a2a37c8&scoped=true&lang=css"

import exportComponent from "/Applications/PROJECTS/CBHI/PONA HEALTH/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a2a37c8"]])

export default __exports__